import { gql } from 'apollo-angular';

const GET_ALL_CATEGORIES_FOR_ORGANIZATION = gql`
  query getAllCategoriesForOrganization(
    $organizationId: Long
    $contextName: String
    $categorizationSchemeName: String!
  ) {
    primaryCategories(
      organizationId: $organizationId
      categorizationSchemeName: $categorizationSchemeName
      customContextName: $contextName
    ) {
      id
      name
      type
      effectiveDate
      parent {
        name
        type
      }
      categorizationScheme {
        name
      }
    }
  }
`;

export default GET_ALL_CATEGORIES_FOR_ORGANIZATION;
